/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-string-refs */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import * as queryString from 'query-string';
import 'url-search-params-polyfill';
import Waypoint from 'react-waypoint';
import PropTypes, { any } from 'prop-types';

import { getPickleBallRating, getRatingDetails, setRatingChoice } from '../../../utils';
import { getEventDateString, titleCase } from '../../../utils/formatting';
import { WarningPopUp } from '../../InfoPopUps';
import BackgroundImage from '../../BackgroundImage';
import { getClickAttrs } from '../../Analytics/gtag';
import { getFindSportTypeEventsSearchUrl } from '../../../utils/events';
import withStatsig from '../../hocs/withStatsig';

import * as actions from '../../../actions/search-actions';

import * as postScoreActions from '../../../actions/post-score-actions';

import styles from './globalSearch.scss';
import Description from '../../text/Description';
import Img from '../../Img';

import { getApiAxiosInstance } from '../../../utils/network';
import TrackedClick from '../../Analytics/TrackedClick';
import config from '../../../../config';
import { debounce } from '../../../utils/debounceUtil';
import { LeagueTypeIds } from '../../../utils/types';
import { canAccessChatWithAce } from '../../../utils/user';
import { globalSearchIDs, navigationIDs } from '../../Analytics/testIDConfig';
import { tomorrowDateGmt } from '../../../pages/SearchPage/Filters/FilterComponents/DateFilter';
import { getFeedPreferences } from '../../../actions/settings-actions';
import GlobalSearchNavItems from './GlobalSearchNavItems';
import GlobalSearchNavItemsV2 from './GlobalSearchNavItems/GlobalSearchNavItemsV2';
import { AllPlayersNavItem, AllEventsNavItem, PlayersNavItemV2, EventsNavItemV2 } from './GlobalSearchNavItems/GlobalSearchNavItemDictionary';
import TeamLeaguesPickleballSearchPills from './TeamLeaguePickleballSearchPills';
import {
    cleanupVoiceflowObserver,
    initializeVoiceflowEmbeddedChat as initializeVoiceflowEmbeddedChatHelper,
    shouldCloseFromVoiceflowMessage,
} from './voiceflowHelpers';
import { getNewClubPath } from '../../../utils/clubs';
import { showSplash } from '../../../actions/splash-actions';

const { leaguesAppHost } = config;
const { ADULT_TEAM_TENNIS, JUNIOR_TEAM_TENNIS } = LeagueTypeIds;
const PICKLEBALL_ID = 2;

// Named export is intentionally kept for unit tests that need the unwrapped component.
export class GlobalSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            showDropDown: false,
            showVoiceflowEmbeddedChat: false,
            clubs: {
                total: 0,
                hits: [],
            },
            events: {
                total: 0,
                hits: [],
            },
            players: {
                total: 0,
                hits: [],
            },
            highSchools: {
                total: 0,
                hits: [],
            },
            colleges: {
                total: 0,
                hits: [],
            },
            query: '',
            searched: false,
            showPopUp: false,
            skip: 0,
        };

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleOnFocus = this.handleOnFocus.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handlePaste = this.handlePaste.bind(this);
        this.fetchResults = this.fetchResults.bind(this);
        this.handleClearClick = this.handleClearClick.bind(this);
        this.handlePlayerClick = this.handlePlayerClick.bind(this);
        this.handleSchoolClick = this.handleSchoolClick.bind(this);
        this.handleClubClick = this.handleClubClick.bind(this);
        this.handleEventClick = this.handleEventClick.bind(this);
        this.handleSeeAllClick = this.handleSeeAllClick.bind(this);
        this.handleSearchExpanderClick = this.handleSearchExpanderClick.bind(this);
        this.handleSearchBackClick = this.handleSearchBackClick.bind(this);
        this.handlePopUpConfirm = this.handlePopUpConfirm.bind(this);
        this.showPopUp = this.showPopUp.bind(this);
        this.updateQueryParams = this.updateQueryParams.bind(this);
        this.showQueryString = this.showQueryString.bind(this);
        this.focusOnInput = this.focusOnInput.bind(this);
        this.loadMoreItems = this.loadMoreItems.bind(this);
        this.handleTypeFilterClick = this.handleTypeFilterClick.bind(this);
        this.handleTeamLeagueClick = this.handleTeamLeagueClick.bind(this);
        this.handleChatWithAceClick = this.handleChatWithAceClick.bind(this);
        this.initializeVoiceflowEmbeddedChat = this.initializeVoiceflowEmbeddedChat.bind(this);
        this.handleVoiceflowWidgetMessage = this.handleVoiceflowWidgetMessage.bind(this);
        this.handleVoiceflowChatClose = this.handleVoiceflowChatClose.bind(this);
        this.setVoiceflowChatContainerRef = this.setVoiceflowChatContainerRef.bind(this);
        this.voiceflowChatContainerRef = null;
        this.voiceflowHeaderObserver = null;
        this.debouncedFetch = debounce(this.debounceSearch, config.searchDebounceMilliseconds);
    }

    componentDidMount() {
        const { feedPreferences, isFeedPreferencesLoading, user } = this.props.auth || {};
        const shouldFetchFeedPreferences = user && !isFeedPreferencesLoading && !feedPreferences;

        if (shouldFetchFeedPreferences) {
            this.props.getFeedPreferences();
        }

        this.props.updateSportTypes(user ? feedPreferences : { showTennisContent: true, showPickleballContent: true });
        this.props.applySearchFilters({
            sportTypes: {
                tennis: user ? !!feedPreferences?.showTennisContent : true,
                pickleball: user ? !!feedPreferences?.showPickleballContent : true,
            },
        });
        console.log('GlobalSearch props', this.props);
        this.props.onRef(this);
        document.addEventListener('mousedown', this.handleClickOutside);
        // Listen for Voiceflow postMessage events (e.g. embedded chat close).
        window.addEventListener('message', this.handleVoiceflowWidgetMessage);
        if (this.props.location.pathname === '/search') {
            const parsed = queryString.parse(this.props.location.search);
            if (parsed.query && parsed.query !== this.state.query) {
                this.setState({
                    isLoading: true,
                    showDropDown: false,
                    query: parsed.query || '',
                    clubs: {
                        total: 0,
                        hits: [],
                    },
                    events: {
                        total: 0,
                        hits: [],
                    },
                    players: {
                        total: 0,
                        hits: [],
                    },
                    highSchools: {
                        total: 0,
                        hits: [],
                    },
                    colleges: {
                        total: 0,
                        hits: [],
                    },
                    skip: 0,
                    // eslint-disable-next-line func-names
                }, function () {
                    this.fetchResults();
                });
                this.showQueryString(parsed.query);
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.search.clearGlobalSearch !== this.props.search.clearGlobalSearch && nextProps.search.clearGlobalSearch === true) {
            this.props.expandSearch(false);
            this.handleClearClick(false);
            this.props.clearGlobalSearch(false);
        }
        if (nextProps.search.mode === 'lookup' && nextProps.search.lookup) {
            if (!nextProps.search.isExpanded) {
                this.handleSearchExpanderClick();
            }
        }

        if (nextProps.search.showDropDown === false) {
            this.setState({
                showDropDown: false,
                showVoiceflowEmbeddedChat: false,
            });
        }
        if (nextProps.auth.user && !this.props.auth.user) {
            this.fetchResults();
        }
        if (this.props.search.updateQueryParams) {
            this.updateQueryParams();
        }
    }

    componentDidUpdate() {
        // Enforce eligibility continuously in case gates/user state change while dropdown is open.
        if (this.state.showVoiceflowEmbeddedChat && !this.getCanAccessChatWithAce()) {
            this.handleVoiceflowChatClose();
        }
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
        document.removeEventListener('mousedown', this.handleClickOutside);
        window.removeEventListener('message', this.handleVoiceflowWidgetMessage);
        this.voiceflowHeaderObserver = cleanupVoiceflowObserver(this.voiceflowHeaderObserver);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    setVoiceflowChatContainerRef(node) {
        this.voiceflowChatContainerRef = node;
    }

    updateQueryParams() {
        if (this.props.location.pathname === '/search') {
            const queryParams = [];
            if (this.props.search.query) {
                queryParams.push(`query=${this.props.search.query}`);
            }
            if (this.props.search.filters) {
                Object.entries(this.props.search.filters).forEach(([key, value]) => {
                    if (key && value) {
                        if (key === 'hsGradYears') {
                            const gradYears = [];
                            Object.entries(value).forEach(([year, bool]) => {
                                if (year && bool) {
                                    gradYears.push(year);
                                }
                            });
                            if (gradYears.length) {
                                queryParams.push(`gradYearHs=${gradYears.join(',')}`);
                            }
                        } else if (key === 'tours') {
                            const tours = [];
                            Object.entries(value).forEach(([tourName, bool]) => {
                                if (tourName && bool) {
                                    tours.push(tourName);
                                }
                            });
                            if (tours.length) {
                                queryParams.push(`tours=${encodeURI(tours.join(','))}`);
                            }
                        } else if (key === 'eventTypes') {
                            const eventTypes = [];
                            Object.entries(value).forEach(([et, bool]) => {
                                if (et && bool) {
                                    eventTypes.push(et);
                                }
                            });
                            if (eventTypes.length) {
                                queryParams.push(`eventTypes=${encodeURI(eventTypes.join(','))}`);
                            }
                        } else if (key === 'eventRegions') {
                            const eventRegions = [];
                            Object.entries(value).forEach(([et, bool]) => {
                                if (et && bool) {
                                    eventRegions.push(et);
                                }
                            });
                            if (eventRegions.length) {
                                queryParams.push(`eventRegions=${encodeURI(eventRegions.join(','))}`);
                            }
                        } else if (key === 'eventTags') {
                            const tags = [];
                            Object.entries(value).forEach(([et, bool]) => {
                                if (et && bool) {
                                    tags.push(et);
                                }
                            });
                            if (tags.length) {
                                queryParams.push(`eventTags=${encodeURI(tags.join(','))}`);
                            }
                        } else if (key === 'eventUtrTypes') {
                            const eventUtrTypes = [];
                            Object.entries(value).forEach(([et, bool]) => {
                                if (et && bool) {
                                    eventUtrTypes.push(et);
                                }
                            });
                            if (eventUtrTypes.length) {
                                queryParams.push(`eventUtrTypes=${encodeURI(eventUtrTypes.join(','))}`);
                            }
                        } else if (key === 'genders') {
                            const genders = [];
                            Object.entries(value).forEach(([gender, bool]) => {
                                if (gender && bool) {
                                    genders.push(gender);
                                }
                            });
                            if (genders.length) {
                                queryParams.push(`genders=${encodeURI(genders.join(','))}`);
                            }
                        } else if (key === 'eventTeamTypes') {
                            const eventTeamTypes = [];
                            Object.entries(value).forEach(([ett, bool]) => {
                                if (ett && bool) {
                                    eventTeamTypes.push(ett);
                                }
                            });
                            if (eventTeamTypes.length) {
                                queryParams.push(`eventTeamTypes=${encodeURI(eventTeamTypes.join(','))}`);
                            }
                        } else if (key === 'ballTypes') {
                            const ballTypes = [];
                            Object.entries(value).forEach(([ballType, isSelected]) => {
                                if (ballType && isSelected) {
                                    ballTypes.push(ballType);
                                }
                            });
                            if (ballTypes.length) {
                                queryParams.push(`ballTypes=${encodeURI(ballTypes.join(','))}`);
                            }
                        } else if (key === 'sportTypes') {
                            const sportTypes = [];
                            Object.entries(value).forEach(([sportType, isSelected]) => {
                                if (sportType && isSelected) {
                                    sportTypes.push(sportType);
                                }
                            });
                            if (sportTypes.length) {
                                queryParams.push(`sportTypes=${encodeURI(sportTypes.join(','))}`);
                            }
                        } else if (typeof value === 'object' && value._isAMomentObject) {
                            queryParams.push(`${key}=${value.format('MM/DD/YYYY')}`);
                        } else {
                            queryParams.push(`${key}=${value}`);
                        }
                    }
                });
            }
            console.log('updateQueryParams', queryParams);
            if (queryParams.length) {
                this.props.history.replace({
                    search: `?${queryParams.join('&')}`,
                });
            }
            this.props.updateQueryParams(false);
        }
    }

    handleClickOutside(event) {
        if ((!(this.wrapperRef?.contains(event.target) ?? true)) && this.state.showDropDown && !this.state.showPopUp) {
            this.setState({
                showDropDown: false,
                showVoiceflowEmbeddedChat: false,
            });
            if (this.props.search.mode === 'lookup' && this.props.search.lookup) {
                this.props.setSearchMode({ mode: 'lookup', lookupType: 'players' });
                this.props.expandSearch(false);
                this.setState({
                    showDropDown: false,
                    showVoiceflowEmbeddedChat: false,
                });
                this.handleClearClick(false);
            } else {
                this.setState({
                    showDropDown: false,
                    showVoiceflowEmbeddedChat: false,
                });
            }
        }
    }

    handleOnFocus() {
        this.setState({
            showDropDown: true,
            showVoiceflowEmbeddedChat: false,
        });
        this.refs.query.value = this.state.query;
    }

    focusOnInput() {
        this.handleOnFocus();
        setTimeout(() => {
            this.refs.query.focus();
        }, 200);
    }

    // eslint-disable-next-line no-shadow
    showQueryString(queryString) {
        if (this.props.location.pathname === '/search' || (this.props.location.pathname !== '/search' && queryString)) {
            if (this.refs.query && queryString) {
                this.refs.query.value = queryString;
            }
        }
    }

    debounceSearch(query) {
        this.setState({
            isLoading: true,
            showDropDown: true,
            query,
            clubs: {
                total: 0,
                hits: [],
            },
            events: {
                total: 0,
                hits: [],
            },
            players: {
                total: 0,
                hits: [],
            },
            highSchools: {
                total: 0,
                hits: [],
            },
            colleges: {
                total: 0,
                hits: [],
            },
            skip: 0,
            // eslint-disable-next-line func-names
        }, function () {
            this.fetchResults();
        });
    }

    handleKeyUp(event) {
        if (event === null || event.target === null) return;
        const query = event.target.value;
        if (query.length > 0) {
            // eslint-disable-next-line no-empty
            if (event.key === 'Enter') {
            } else {
                this.debouncedFetch(query);
            }
        } else {
            this.setState({
                query: '',
                clubs: {
                    total: 0,
                    hits: [],
                },
                events: {
                    total: 0,
                    hits: [],
                },
                players: {
                    total: 0,
                    hits: [],
                },
                highSchools: {
                    total: 0,
                    hits: [],
                },
                colleges: {
                    total: 0,
                    hits: [],
                },
                skip: 0,
                showDropDown: true,
            });
        }
    }

    handlePaste(event) {
        const { target } = event;

        setTimeout(() => {
            const query = target.value.trim();
            if (query.length > 0) {
                if (event.key === 'Enter') {
                    this.setState({
                        showDropDown: false,
                    });
                    if (this.props.location.pathname !== '/search') {
                        this.props.history.push('/search');
                    }
                } else {
                    this.setState({
                        isLoading: true,
                        showDropDown: true,
                        query,
                        clubs: {
                            total: 0,
                            hits: [],
                        },
                        events: {
                            total: 0,
                            hits: [],
                        },
                        players: {
                            total: 0,
                            hits: [],
                        },
                        highSchools: {
                            total: 0,
                            hits: [],
                        },
                        colleges: {
                            total: 0,
                            hits: [],
                        },
                        skip: 0,
                        // eslint-disable-next-line func-names
                    }, function () {
                        this.fetchResults();
                    });
                }
            } else {
                this.setState({
                    query: '',
                    clubs: {
                        total: 0,
                        hits: [],
                    },
                    events: {
                        total: 0,
                        hits: [],
                    },
                    players: {
                        total: 0,
                        hits: [],
                    },
                    highSchools: {
                        total: 0,
                        hits: [],
                    },
                    colleges: {
                        total: 0,
                        hits: [],
                    },
                    skip: 0,
                    showDropDown: true,
                });
            }
        }, 200);
    }

    fetchResults() {
        console.log('GlobalSearch fetchResults()');
        const axiosInstance = getApiAxiosInstance();

        const { mode, lookupType, lookupCount, lookUpParams } = this.props.search;
        const params = new URLSearchParams();
        const { searchPageType } = this.props.search;
        params.append('query', this.state.query);
        params.append('top', (mode === 'lookup' && lookupCount) ? lookupCount : 10);
        params.append('skip', (mode === 'lookup' && this.state.skip) ? this.state.skip : 0);
        if (lookUpParams && lookUpParams.length > 0) {
            lookUpParams.forEach((param) => {
                params.append(param.key, param.value);
            });
        }

        /* if (filters && filters.distance && filters.lat && filters.lng) {
            params.append('distance', filters.distance);
            params.append('pin', `${filters.lat},${filters.lng}`);
        } */

        const that = this;
        const { CancelToken } = axios;

        // if (this.state.query.length > 0) {
        if (that.cancel !== undefined) {
            that.cancel();
        }

        let searchUrl = `v2/search${mode === 'lookup' ? `/${lookupType}` : ''}?schoolClubSearch=true`;
        if (searchPageType === 'playerPostScore' && mode === 'lookup' && lookupType === 'players') {
            searchUrl = `v1/score/search/players`;
        }
        axiosInstance.get(searchUrl, {
            cancelToken: new CancelToken((c) => {
                that.cancel = c;
            }),
            params,
        }).then((response) => {
            console.log('search res', mode, lookupType, lookupCount, response);
            if (mode === 'lookup' && lookupType) {
                const emptyData = { hits: [], total: 0 };
                let players;
                let clubs;
                let events;
                let colleges;
                let highSchools;
                if (that.state.skip) {
                    players = lookupType === 'players' ? {
                        ...that.state.players,
                        hits: [...that.state.players.hits, ...response.data.hits],
                    } : emptyData;
                    clubs = lookupType === 'clubs' ? {
                        ...that.state.clubs,
                        hits: [...that.state.clubs.hits, ...response.data.hits],
                    } : emptyData;
                    events = lookupType === 'events' ? {
                        ...that.state.events,
                        hits: [...that.state.events.hits, ...response.data.hits],
                    } : emptyData;
                    colleges = lookupType === 'colleges' ? {
                        ...that.state.colleges,
                        hits: [...that.state.colleges.hits, ...response.data.hits],
                    } : emptyData;
                    highSchools = lookupType === 'highSchools' ? {
                        ...that.state.highSchools,
                        hits: [...that.state.highSchools.hits, ...response.data.hits],
                    } : emptyData;
                } else {
                    players = lookupType === 'players' ? response.data : emptyData;
                    clubs = lookupType === 'clubs' ? response.data : emptyData;
                    events = lookupType === 'events' ? response.data : emptyData;
                    colleges = lookupType === 'colleges' ? response.data : emptyData;
                    highSchools = lookupType === 'highSchools' ? response.data : emptyData;
                }
                const stateToSet = {
                    clubs,
                    events,
                    players,
                    highSchools,
                    colleges,
                    isLoading: false,
                    searched: true,
                };
                if (that.state.storeWhenLoaded) {
                    stateToSet.storeWhenLoaded = false;
                    that.props.storeResults(that.state.query, {
                        players,
                        highSchools,
                        colleges,
                        clubs,
                        events,
                    });
                }
                stateToSet.isEnd = response.data.totalAllowed < lookupCount || (that.state.skip && response.data.totalAllowed < that.state.skip);
                that.setState(stateToSet);
            } else {
                const { clubs, events, players, highSchools, colleges } = response.data;
                const stateToSet = {
                    clubs,
                    events,
                    players,
                    highSchools,
                    colleges,
                    isLoading: false,
                    searched: true,
                };
                if (that.state.storeWhenLoaded) {
                    stateToSet.storeWhenLoaded = false;
                    that.props.storeResults(that.state.query, { players, highSchools, colleges, clubs, events });
                }
                that.setState(stateToSet);
            }
        }).catch((error) => {
            console.log(error);
            if (error === 'Cancel') {
                that.setState({
                    isLoading: true,
                    searched: false,
                });
            } else {
                that.setState({
                    isLoading: false,
                    searched: true,
                });
            }
        });
    }

    async handleSeeAllClick(e, typeFilter) {
        const { gotoSearchResults } = this.props.search;
        if (!gotoSearchResults) {
            return;
        }
        if (e) {
            e.preventDefault();
        }
        const { query, players, highSchools, colleges, clubs, events } = this.state;
        const stateToSet = {
            showDropDown: false,
        };
        if (this.state.isLoading && !this.state.searched) {
            stateToSet.storeWhenLoaded = true;
            this.props.setLoadingFlag();
        } else {
            this.props.storeResults(query, { players, highSchools, colleges, clubs, events }, true);
        }
        this.setState(stateToSet);
        this.props.updateSearchQuery(query);
        if (typeFilter) {
            this.props.setTypeFilter(typeFilter);
        }
        this.props.expandSearch(false);

        const { checkGate, featureGates } = this.props;
        const isEventSearchV2Enabled = checkGate(featureGates.EVENT_SEARCH_V2);
        const eventsType = 'events';

        if (isEventSearchV2Enabled && typeFilter === eventsType) {
            const searchQuery = query ? `?query=${encodeURIComponent(query)}` : '';
            this.props.history.push({ pathname: '/search', search: searchQuery });
            return;
        }

        // Legacy behavior
        if (this.props.location.pathname !== '/search') {
            this.props.history.push('/search');
        }
    }

    loadMoreItems() {
        const { isLoading, isEnd } = this.state;
        if (!isLoading && !isEnd) {
            this.setState((prevState) => ({
                isLoading: true,
                // eslint-disable-next-line react/no-access-state-in-setstate
                skip: (prevState.skip + (this.props.search.lookupCount || 10)),
                // eslint-disable-next-line func-names
            }, function () {
                this.fetchResults();
            }));
        }
    }

    handleClearClick(keepInputInFocus) {
        this.refs.query.value = '';
        this.setState({
            query: '',
            clubs: {
                total: 0,
                hits: [],
            },
            events: {
                total: 0,
                hits: [],
            },
            players: {
                total: 0,
                hits: [],
            },
            highSchools: {
                total: 0,
                hits: [],
            },
            colleges: {
                total: 0,
                hits: [],
            },
            skip: 0,
            showDropDown: !!keepInputInFocus,
            searched: false,
        });
        if (keepInputInFocus) {
            setTimeout(() => {
                this.refs.query.focus();
            }, 200);
        }
        this.props.updateSearchQuery('');
    }

    parsePlayerName(player) {
        if (player.query) {
            const str = player.query.trim();
            // eslint-disable-next-line prefer-destructuring
            player.firstName = str.split(/\s(.+)/)[0];
            player.lastName = str.split(/\s(.+)/)[1] || '';
        } else if (player.NamePart1) {
            player.firstName = player.NamePart1;
            if (player.NamePart3) {
                player.lastName = player.NamePart3;
            }
        }
    }

    async handlePlayerClick(player, ev) {
        if (this.props.search.mode === 'lookup' && this.props.search.lookup) {
            this.parsePlayerName(player);

            if (!player.firstName || !player.lastName) {
                this.showPopUp(ev, 'Please enter player\'s first and last name before inviting them to UTR Sports.');
                return;
            }

            this.props.postScoreAddPlayer(this.props.search.lookup, player);
            this.props.setSearchMode({ mode: 'lookup', lookupType: 'players' });
            this.props.expandSearch(false);
            this.setState({
                showDropDown: false,
            });
            this.handleClearClick(false);

            // otherwise default search behavior
        } else {
            this.props.history.push(`/profiles/${player.id}`);
            this.props.expandSearch(false);
            this.setState({
                showDropDown: false,
            });
            this.handleClearClick(false);
        }
    }

    handleSchoolClick(schoolClub) {
        const { isCollege } = schoolClub;
        const isClubRedirectEnabled = this.props.checkGate(this.props.featureGates.CLUB_LINKS_REDIRECT);
        const newClubPath = isCollege ? 'college' : 'high-school';
        if (isClubRedirectEnabled) {
            this.props.showSplash();
            window.location.href = `${config.nextAppHost}/${newClubPath}/${schoolClub.id}`;
            return;
        }
        this.props.history.push(`/${isCollege ? 'colleges' : 'schools'}/${schoolClub.id}`);
        this.props.expandSearch(false);
        this.setState({
            showDropDown: false,
        });
        this.handleClearClick(false);
    }

    handleEventClick(event) {
        this.props.history.push(`/events/${event.id}`);
        this.props.expandSearch(false);
        this.setState({
            showDropDown: false,
        });
        this.handleClearClick(false);
    }

    handleClubClick(club) {
        const isClubRedirectEnabled = this.props.checkGate(this.props.featureGates.CLUB_LINKS_REDIRECT);
        const newClubPath = getNewClubPath(club.tierTypeId);
        if (isClubRedirectEnabled && club.tierTypeId) {
            this.props.showSplash();
            window.location.href = `${config.nextAppHost}/${newClubPath}/${club.id}`;
            return;
        }
        this.props.history.push(`/clubs/${club.id}`);
        this.props.expandSearch(false);
        this.setState({
            showDropDown: false,
        });
        this.handleClearClick(false);
    }

    handleSearchExpanderClick() {
        this.props.expandSearch(true);
        setTimeout(() => {
            this.refs.query.focus();
        }, 200);
    }

    handleSearchBackClick() {
        this.refs.query.value = '';
        this.setState({
            query: '',
            clubs: {
                total: 0,
                hits: [],
            },
            events: {
                total: 0,
                hits: [],
            },
            players: {
                total: 0,
                hits: [],
            },
            highSchools: {
                total: 0,
                hits: [],
            },
            colleges: {
                total: 0,
                hits: [],
            },
            skip: 0,
            showDropDown: false,
            showVoiceflowEmbeddedChat: false,
            searched: false,
        });
        this.props.expandSearch(false);
    }

    // prevent the fixed positioned div from scrolling the body
    preventDefault(e) {
        e.preventDefault();
    }

    /* start popup code */
    handlePopUpConfirm() {
        // only closes pop up and reenables dropdown
        this.setState({
            showPopUp: false,
            popUpMessage: null,
        }, () => {
            this.refs.query.focus();
        });
    }

    showPopUp(ev, message) {
        this.setState({
            showPopUp: true,
            popUpMessage: message,
        });
    }

    /* end popup code */

    getCanAccessChatWithAce() {
        const { checkGate, featureGates, auth } = this.props;
        const isChatWithAceEnabled = checkGate(featureGates.CHAT_WITH_ACE_ENABLED);

        return canAccessChatWithAce({
            user: auth?.user,
            isChatWithAceEnabled,
        });
    }

    handleOnFindEventsClick = (sportType) => {
        const url = getFindSportTypeEventsSearchUrl(sportType);
        window.location.href = url;
    };

    // Closes embedded Voiceflow chat and resets related UI/observer state.
    handleVoiceflowChatClose() {
        this.voiceflowHeaderObserver = cleanupVoiceflowObserver(this.voiceflowHeaderObserver);
        this.setState({
            showDropDown: false,
            showVoiceflowEmbeddedChat: false,
        });
        this.props.expandSearch(false);
    }

    // Handles Voiceflow postMessage events and closes embedded chat on a Voiceflow close signal.
    handleVoiceflowWidgetMessage(event) {
        if (!this.state.showVoiceflowEmbeddedChat || !event?.data) {
            return;
        }

        const { isMalformed, shouldClose } = shouldCloseFromVoiceflowMessage(event.data);
        if (isMalformed) {
            // eslint-disable-next-line no-console
            console.warn('Ignoring malformed Voiceflow widget message');
            return;
        }

        if (shouldClose) {
            this.handleVoiceflowChatClose();
        }
    }

    handleUpdateSportType = (sportType, entityType) => {
        const { user, feedPreferences } = this.props.auth || {};
        const isGlobalSearchOrderV2 = this.props.checkGate(this.props.featureGates.GLOBAL_SEARCH_V2);
        const allPlayersEntityType = isGlobalSearchOrderV2 ? PlayersNavItemV2.entityType : AllPlayersNavItem.entityType;
        if (entityType === allPlayersEntityType && user) {
            this.props.updateSportTypes(feedPreferences || { showTennisContent: true, showPickleballContent: true });
        } else {
            this.props.updateSportTypes(sportType);
        }
    };

    handleEventsClick = (sportType, entityType) => {
        const { user, feedPreferences } = this.props.auth || {};
        const isGlobalSearchOrderV2 = this.props.checkGate(this.props.featureGates.GLOBAL_SEARCH_V2);
        const allEventsEntityType = isGlobalSearchOrderV2 ? EventsNavItemV2.entityType : AllEventsNavItem.entityType;
        if (entityType === allEventsEntityType && user) {
            this.handleOnFindEventsClick(feedPreferences || { showTennisContent: true, showPickleballContent: true });
        } else {
            this.handleOnFindEventsClick(sportType);
        }
    };

    handleTypeFilterClick(typeFilter, tourFilter) {
        this.setState({
            showDropDown: false,
        });
        this.props.expandSearch(false);
        const user = this.props.auth?.user;
        const updatedTypeFilter = typeFilter === 'pickleball' ? 'events' : typeFilter;
        this.props.updateSearchQuery('');
        this.props.setTypeFilter(updatedTypeFilter, true);
        const pickleballFilter = 'pickleball';
        if (typeFilter === pickleballFilter) {
            this.props.applySearchFilters({
                sportTypes: {
                    tennis: false,
                    pickleball: true,
                },
                startDate: tomorrowDateGmt,
            });
        } else {
            this.props.applySearchFilters({
                sportTypes: {
                    tennis: this.props.auth?.user ? !!this.props?.auth?.feedPreferences?.showTennisContent : true,
                    pickleball: this.props.auth?.user ? !!this.props?.auth?.feedPreferences?.showPickleballContent : true,
                },
                startDate: tomorrowDateGmt,
            });
        }
        if (user && updatedTypeFilter === 'clubs') {
            this.props.applySearchFilters({
                locationInputValue: user.location.display,
                locationCountryName: '',
                locationStateName: '',
                distance: '50mi',
                location: user.location.display,
                lat: user.location.latLng[0],
                lng: user.location.latLng[1],
            }, true);
        }
        if (user && updatedTypeFilter === 'events') {
            // If authenticated, apply tour filter with specific parameters if available; otherwise, use default search
            if (tourFilter) {
                this.props.applySearchFilters({
                    tours: tourFilter,
                    sportTypes: {
                        tennis: true,
                        pickleball: true,
                    },
                    startDate: tomorrowDateGmt,
                }, true);
            } else {
                this.props.applySearchFilters({
                    locationInputValue: user.location.display,
                    locationCountryName: '',
                    locationStateName: '',
                    distance: '50mi',
                    location: user.location.display,
                    lat: user.location.latLng[0],
                    lng: user.location.latLng[1],
                    sportTypes: {
                        tennis: this.props.auth?.user ? !!this.props?.auth?.feedPreferences?.showTennisContent : true,
                        pickleball: this.props.auth?.user ? !!this.props?.auth?.feedPreferences?.showPickleballContent : true,
                    },
                    startDate: tomorrowDateGmt,
                });
            }
        } else if (updatedTypeFilter === 'events' && tourFilter) {
            // Apply the tour filter for unauthenticated users
            this.props.applySearchFilters({
                tours: tourFilter,
                sportTypes: {
                    tennis: true,
                    pickleball: true,
                },
                startDate: tomorrowDateGmt,
            }, true);
        } else {
            // do nothing
        }

        const juniorCircuits = 'juniorCircuits';
        if (typeFilter === juniorCircuits) {
            this.props.applySearchFilters({
                regionSearch: true,
            });
        }
        if (this.props.location.pathname !== '/search') {
            this.props.history.push('/search');
        }
    }

    handleTeamLeagueClick(leagueTypeId) {
        this.setState({ showDropDown: false });
        this.props.expandSearch(false);
        window.location = `${leaguesAppHost}/search/league/${leagueTypeId}`;
        this.props.applySearchFilters({
            sportTypes: {
                tennis: this.props.auth?.user ? !!this.props?.auth?.feedPreferences?.showTennisContent : true,
                pickleball: this.props.auth?.user ? !!this.props?.auth?.feedPreferences?.showPickleballContent : true,
            },
        });
    }

    async initializeVoiceflowEmbeddedChat() {
        try {
            const target = this.voiceflowChatContainerRef || document.getElementById('voiceflow-chat-frame');
            this.voiceflowHeaderObserver = await initializeVoiceflowEmbeddedChatHelper({
                target,
                userId: this.props.auth.user.claimedPlayer?.playerId,
                firstName: this.props.auth.user.claimedPlayer?.firstName,
                lastName: this.props.auth.user.claimedPlayer?.lastName,
                isPowered: this.props.auth.user.isPowered,
                projectId: config.voiceflowProjectId,
                versionId: config.voiceflowVersionId,
                onClose: this.handleVoiceflowChatClose,
                existingObserver: this.voiceflowHeaderObserver,
                setObserver: (observer) => {
                    this.voiceflowHeaderObserver = observer;
                },
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Voiceflow chat failed to load', error);
        }
    }

    handleChatWithAceClick() {
        if (!this.getCanAccessChatWithAce()) {
            return;
        }

        this.setState({
            showDropDown: true,
            showVoiceflowEmbeddedChat: true,
        }, () => {
            this.initializeVoiceflowEmbeddedChat();
        });
    }

    render() {
        const { mode, lookupType, lookup, displayText, allowInvite, displayFilters } = this.props.search;
        const placeholder = displayText || 'Search';
        const canShowChatWithAce = this.getCanAccessChatWithAce();
        const shouldShowVoiceflowEmbeddedChat = this.state.showVoiceflowEmbeddedChat && canShowChatWithAce;

        const renderPlayer = (player, i) => {
            const { displayName, descriptionShort, gender, location, playerProfileImages, isPro } = player;
            const userIsPowered = this.props.auth?.user?.isPowered || false;
            const isPickleBall = this.props.search.sportTypeId === PICKLEBALL_ID;
            const rating = isPickleBall ? getPickleBallRating(player, null) : getRatingDetails(setRatingChoice({ player }), userIsPowered, isPro, false, false);

            let description = '';
            if (descriptionShort) {
                description = [descriptionShort];
            } else {
                description = location?.display ? [location.display] : [];
            }
            const descriptionItems = [
                ...(gender ? [gender.charAt(0)] : []),
                ...(rating.showPBRRating ? [rating.pbrRating?.ratingDisplay] : (rating && this.props.auth.user ? [rating.value] : [])),
                ...(description),
            ];
            return (
                ((mode === 'lookup') || (mode !== 'lookup' && i < 4)) ? (
                    <TrackedClick
                        eventName="Global Search Result Clicked"
                        label={this.state.query}
                        traits={{
                            entityId: player.id,
                            entityType: 'players',
                            query: this.state.query,
                        }}
                    >
                        <div
                            className={`row ${styles.globalSearchDropdownOption}`}
                            onClick={(ev) => this.handlePlayerClick(player, ev)}
                            key={`p${i}`}
                            {...getClickAttrs({
                                category: 'Global Search Result',
                                context: `Player Clicked - playerId: ${player.id} - query: ${this.state.query}`,
                                location: 'Global Search',
                            })}
                        >
                            <div className="col-2">
                                <BackgroundImage
                                    baseUrl={'/v1/player/'}
                                    defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                                    images={playerProfileImages}
                                    imageType={'thumbnail'}
                                    extraCls={'playerThumbnailImage'}
                                />
                            </div>
                            <div className="col-10">
                                <div className={`${styles.name} show-ellipsis`}><span
                                    dangerouslySetInnerHTML={{ __html: titleCase(displayName) }}
                                /> {rating.verified
                                    ? <div className="utr-icon icon-verified-blue d-inline-block" /> : ''}
                                </div>
                                <div className={`${styles.place} show-ellipsis`}>
                                    <Description desc={descriptionItems} />
                                </div>
                            </div>
                        </div>
                    </TrackedClick>
                ) : null
            );
        };

        const renderSchool = (schoolClub, i) => {
            const { id, name, location, profilePhotoUrl } = schoolClub;
            const { displayName, shortName } = schoolClub.school;
            const photoUrl = profilePhotoUrl ? `/v1/club/${profilePhotoUrl}?variant=icon` : null;
            const descriptionItems = [
                ...(location?.display ? [location.display] : []),
            ];
            return (
                ((mode === 'lookup') || (mode !== 'lookup' && i < 4)) ? (
                    <TrackedClick
                        eventName="Global Search Result Clicked"
                        label={this.state.query}
                        traits={{
                            entityId: id,
                            entityType: schoolClub.isCollege ? 'colleges' : 'highschools',
                            query: this.state.query,
                        }}
                    >
                        <div
                            className={`row ${styles.globalSearchDropdownOption}`}
                            onClick={() => this.handleSchoolClick(schoolClub)}
                            key={`s${i}`}
                            {...getClickAttrs({
                                category: 'Global Search Result',
                                context: `School Clicked - id: ${id} - query: ${this.state.query}`,
                                location: 'Global Search',
                            })}
                        >
                            <div className="col-2">
                                {
                                    photoUrl
                                        ? (
                                            <Img
                                                className={styles.globalSearchDropdownOptionImage}
                                                src={photoUrl}
                                                srcSet={`${photoUrl}&size=1x, ${photoUrl}&size=2x 2x, ${photoUrl}&size=3x 3x`}
                                                onError={(e) => {
                                                    e.target.src = `/img/v2/icons/icon-avatar-${schoolClub.isCollege ? 'college' : 'school'}.svg`;
                                                    e.target.srcset = `/img/v2/icons/icon-avatar-${schoolClub.isCollege ? 'college' : 'school'}.svg`;
                                                }}
                                            />
                                        )
                                        : (
                                            <Img
                                                className={styles.globalSearchDropdownOptionImage}
                                                src={`/img/v2/icons/icon-avatar-${schoolClub.isCollege ? 'college' : 'school'}.svg`}
                                            />
                                        )
                                }
                            </div>
                            <div className="col-10">
                                <div
                                    className={`${styles.name} show-ellipsis d-block d-md-none`}
                                    dangerouslySetInnerHTML={{ __html: name || shortName || displayName }}
                                />
                                <div
                                    className={`${styles.name} show-ellipsis d-none d-md-block`}
                                    dangerouslySetInnerHTML={{ __html: name || displayName }}
                                />
                                <div className={`${styles.place} show-ellipsis`}>
                                    <Description desc={descriptionItems} />
                                </div>
                            </div>
                        </div>
                    </TrackedClick>
                ) : null
            );
        };

        const renderClub = (club, i) => {
            const { name, location, memberCount } = club;
            const descriptionItems = [
                ...(location?.display ? [location.display] : []),
                ...(memberCount && memberCount >= 10 ? [`${memberCount} member${memberCount && memberCount > 1 ? 's' : ''}`] : []),
            ];
            return (
                ((mode === 'lookup') || (mode !== 'lookup' && i < 4)) ? (
                    <TrackedClick
                        eventName="Global Search Result Clicked"
                        label={this.state.query}
                        traits={{
                            entityId: club.id,
                            entityType: 'clubs',
                            query: this.state.query,
                        }}
                    >
                        <div
                            className={`row ${styles.globalSearchDropdownOption}`}
                            onClick={() => this.handleClubClick(club)}
                            key={`c${i}`}
                            {...getClickAttrs({
                                category: 'Global Search Result',
                                context: `Club Clicked - clubId: ${club.id} - query: ${this.state.query}`,
                                location: 'Global Search',
                            })}
                        >
                            <div className="col-2">
                                <Img
                                    className={styles.globalSearchDropdownOptionImage}
                                    src={'/img/v2/icons/icon-avatar-club.svg'}
                                />
                            </div>
                            <div className="col-10">
                                <div
                                    className={`${styles.name} show-ellipsis`}
                                    dangerouslySetInnerHTML={{ __html: name }}
                                />
                                <div className={`${styles.place} show-ellipsis`}>
                                    <Description desc={descriptionItems} />
                                </div>
                            </div>
                        </div>
                    </TrackedClick>
                ) : null
            );
        };

        const renderEvent = (event, i, entityType) => {
            const { name, eventSchedule, eventState } = event;
            const descriptionItems = [];
            if (eventSchedule) {
                descriptionItems.push(getEventDateString(eventSchedule, eventState?.value === 'completed'));
            }
            return (
                ((mode === 'lookup') || (mode !== 'lookup' && i < 4)) ? (
                    <TrackedClick
                        eventName="Global Search Result Clicked"
                        label={this.state.query}
                        traits={{
                            entityId: event.id,
                            entityType,
                            query: this.state.query,
                        }}
                    >
                        <div
                            className={`row ${styles.globalSearchDropdownOption}`}
                            onClick={() => this.handleEventClick(event)}
                            key={`e${i}`}
                            {...getClickAttrs({
                                category: 'Global Search Result',
                                context: `Event Clicked - eventId: ${event.id} - query: ${this.state.query}`,
                                location: 'Global Search',
                            })}
                        >
                            <div className="col-2">
                                <Img
                                    className={styles.globalSearchDropdownOptionImage}
                                    src={'/img/v2/icons/icon-avatar-event.svg'}
                                />
                            </div>
                            <div className="col-10">
                                <div
                                    className={`${styles.name} show-ellipsis`}
                                    dangerouslySetInnerHTML={{ __html: name }}
                                />
                                <div className={`${styles.place} show-ellipsis`}>
                                    <Description desc={descriptionItems} />
                                </div>
                            </div>
                        </div>
                    </TrackedClick>
                ) : null
            );
        };

        // eslint-disable-next-line consistent-return
        const renderWaypoint = () => {
            if (!this.state.isLoading) {
                return (
                    <Waypoint
                        onEnter={this.loadMoreItems}
                        threshold={2.0}
                    />
                );
            }
        };

        const renderDropdown = () => {
            if (shouldShowVoiceflowEmbeddedChat) {
                return (
                    <div className={styles.globalSearchDropDown}>
                        <div
                            id="voiceflow-chat-frame"
                            ref={this.setVoiceflowChatContainerRef}
                            className={styles.voiceflowEmbeddedChatContainer}
                        />
                    </div>
                );
            }

            const { checkGate, featureGates } = this.props;
            const isNewGlobalSearchOrder = checkGate(featureGates.GLOBAL_SEARCH_V2);
            const showTennisContent = !!this.props.auth?.feedPreferences?.showTennisContent;
            const showPickleballContent = !!this.props.auth?.feedPreferences?.showPickleballContent;
            const tennisSportTypeIsSelected = !!this.props.search?.filterInputs?.sportTypes?.tennis;
            const pickleballSportTypeIsSelected = !!this.props.search?.filterInputs?.sportTypes?.pickleball;
            const paidHits = 'paidHits';
            const paidHitClubs = 'paidHitClubs';
            const userIsNotAuthenticated = !this.props.auth?.user;
            const tennisConditions = {
                sportTypeSelected: tennisSportTypeIsSelected,
                noSportTypeSelectedAndShowContent: !tennisSportTypeIsSelected && !pickleballSportTypeIsSelected && showTennisContent,
            };
            const pickleballConditions = {
                sportTypeSelected: pickleballSportTypeIsSelected,
                noSportTypeSelectedAndShowContent: !pickleballSportTypeIsSelected && !tennisSportTypeIsSelected && showPickleballContent,
            };
            const showTennisItems = tennisConditions.sportTypeSelected || tennisConditions.noSportTypeSelectedAndShowContent || userIsNotAuthenticated;
            const showPickleballItems = pickleballConditions.sportTypeSelected || pickleballConditions.noSportTypeSelectedAndShowContent || userIsNotAuthenticated;
            const queryEntered = this.state.query?.length > 0;
            const filtersVisible = displayFilters;
            const displayGlobalSearchV2 = !queryEntered && filtersVisible && this.props.showGlobalSearchV2;
            const displayGlobalSearchPills = !queryEntered && filtersVisible && !this.props.showGlobalSearchV2;

            return (
                <div>
                    {displayGlobalSearchV2 && (
                        isNewGlobalSearchOrder ? (
                            <GlobalSearchNavItemsV2
                                onFilterClick={this.handleTypeFilterClick}
                                onTeamLeagueClick={this.handleTeamLeagueClick}
                                onEventsClick={this.handleEventsClick}
                                onUpdateSportType={this.handleUpdateSportType}
                                onChatWithAceClick={this.handleChatWithAceClick}
                                canAccessChatWithAce={canShowChatWithAce}
                            />
                        ) : (
                            <GlobalSearchNavItems
                                onFilterClick={this.handleTypeFilterClick}
                                onTeamLeagueClick={this.handleTeamLeagueClick}
                                onEventsClick={this.handleEventsClick}
                                onUpdateSportType={this.handleUpdateSportType}
                                onChatWithAceClick={this.handleChatWithAceClick}
                                canAccessChatWithAce={canShowChatWithAce}
                            />
                        )
                    )}
                    <div className={styles.globalSearchDropDown}>
                        {/* check for displayFilters since we dont show filter options in post score. which is explicitly set to false there */}
                        {displayGlobalSearchPills && (
                            <div className={`filter-wrapper`}>
                                <div className={`filter-title text-highlight4`}>
                                    {mode === 'lookup' && lookupType === 'players' ? 'Who' : 'What'} are you looking for?
                                </div>
                                <div className={`filter-buttons`}>
                                    <TrackedClick
                                        eventName="Global Search Category Clicked"
                                        label="Players"
                                        traits={{
                                            entityType: 'players',
                                        }}
                                    >
                                        <button
                                            className={`btn btn-sm btn-primary`}
                                            onClick={() => {
                                                this.handleTypeFilterClick('players');
                                                this.props.updateSportTypes(this.props.auth?.user ? this.props?.auth?.feedPreferences : { showTennisContent: true, showPickleballContent: true });
                                            }}
                                            {...getClickAttrs({
                                                category: 'Global Search Category',
                                                context: `Players`,
                                                location: 'Global search CTA',
                                                testid: `${globalSearchIDs.players.component}-${globalSearchIDs.players.location}-${globalSearchIDs.players.id}`,
                                            })}
                                        >
                                            Players
                                        </button>
                                    </TrackedClick>
                                    <TrackedClick
                                        eventName="Global Search Category Clicked"
                                        label="All Events"
                                        traits={
                                            {
                                                entityType: 'events',
                                            }
}
                                    >
                                        <button
                                            className={`btn btn-sm btn-primary`}
                                            onClick={() => {
                                                this.handleOnFindEventsClick({ showTennisContent: true, showPickleballContent: true });
                                                this.props.updateSportTypes(this.props.auth?.user ? this.props?.auth?.feedPreferences : { showTennisContent: true, showPickleballContent: true });
                                            }}
                                            {...getClickAttrs({
                                                category: 'Global Search Category',
                                                context: `All Events`,
                                                location: 'Global search CTA',
                                                testid: `${globalSearchIDs.events.component}-${globalSearchIDs.events.location}-${globalSearchIDs.events.id}`,
                                            })}
                                        >
                                            All Events
                                        </button>
                                    </TrackedClick>
                                    <TrackedClick
                                        eventName="Global Search Category Clicked"
                                        label="Flex Leagues"
                                        traits={{
                                            entityType: 'Flex League events',
                                        }}
                                    >
                                        <button
                                            className={`btn btn-sm btn-primary`}
                                            onClick={() => {
                                                this.handleTypeFilterClick('flexLeagues');
                                                this.props.updateSportTypes(this.props.auth?.user ? this.props?.auth?.feedPreferences : { showTennisContent: true, showPickleballContent: true });
                                            }}
                                            {...getClickAttrs({
                                                category: 'Global Search Category',
                                                context: `Flex Leagues`,
                                                location: 'Global search CTA',
                                                testid: `${globalSearchIDs.flexLeagues.component}-${globalSearchIDs.flexLeagues.location}-${globalSearchIDs.flexLeagues.id}`,
                                            })}
                                        >
                                            Flex Leagues
                                        </button>
                                    </TrackedClick>
                                    <TrackedClick
                                        eventName="Global Search Category Clicked"
                                        label="Team Tennis"
                                        traits={{
                                            entityType: 'Team League Events',
                                        }}
                                    >
                                        <button
                                            className={`btn btn-sm btn-primary`}
                                            onClick={() => this.handleTypeFilterClick('teamLeagues')}
                                            {...getClickAttrs({
                                                category: 'Global Search Category',
                                                context: `Team Tennis`,
                                                location: 'Global search CTA',
                                                testid: `${globalSearchIDs.teamTennis.component}-${globalSearchIDs.teamTennis.location}-${globalSearchIDs.teamTennis.id}`,
                                            })}
                                        >
                                            Team Tennis
                                        </button>
                                    </TrackedClick>
                                    {showTennisItems && (
                                        <>
                                            <TrackedClick
                                                eventName="Global Search Category Clicked"
                                                label="Adult Team Tennis"
                                                traits={
                                                    {
                                                        entityType: 'Adult Team Tennis',
                                                    }
                                                }
                                            >
                                                <button
                                                    type="button"
                                                    className={`btn btn-sm btn-primary`}
                                                    onClick={() => {
                                                        this.handleTeamLeagueClick(ADULT_TEAM_TENNIS);
                                                        this.props.updateSportTypes(this.props.auth?.user ? this.props?.auth?.feedPreferences : { showTennisContent: true, showPickleballContent: true });
                                                    }}
                                                    {...getClickAttrs({
                                                        category: 'Global Search Category',
                                                        context: `Adult Team Tennis`,
                                                        location: 'Global search CTA',
                                                        testid: `${globalSearchIDs.adultTeamTennis.component}-${globalSearchIDs.adultTeamTennis.location}-${globalSearchIDs.adultTeamTennis.id}`,
                                                    })}
                                                >
                                                    Adult Team Tennis
                                                </button>
                                            </TrackedClick>
                                            <TrackedClick
                                                eventName="Global Search Category Clicked"
                                                label="Junior Team Tennis"
                                                traits={{
                                                    entityType: 'Junior Team Tennis',
                                                }}
                                            >
                                                <button
                                                    type="button"
                                                    className={`btn btn-sm btn-primary`}
                                                    onClick={() => {
                                                        this.handleTeamLeagueClick(JUNIOR_TEAM_TENNIS);
                                                        this.props.updateSportTypes(this.props.auth?.user ? this.props?.auth?.feedPreferences : { showTennisContent: true, showPickleballContent: true });
                                                    }}
                                                    {...getClickAttrs({
                                                        category: 'Global Search Category',
                                                        context: `Junior Team Tennis`,
                                                        location: 'Global search CTA',
                                                        testid: `${globalSearchIDs.juniorTeamTennis.component}-${globalSearchIDs.juniorTeamTennis.location}-${globalSearchIDs.juniorTeamTennis.id}`,
                                                    })}
                                                >
                                                    Junior Team Tennis
                                                </button>
                                            </TrackedClick>
                                            <TrackedClick
                                                eventName="Global Search Category Clicked"
                                                label="UTR Pro Tennis Tour"
                                                traits={{
                                                    entityType: 'Pro Tennis events',
                                                }}
                                            >
                                                <button
                                                    className={`btn btn-sm btn-primary`}
                                                    onClick={() => this.handleTypeFilterClick('proTennisTour')}
                                                    {...getClickAttrs({
                                                        category: 'Global Search Category',
                                                        context: `UTR Pro Tennis Tour`,
                                                        location: 'Global search CTA',
                                                        testid: `${globalSearchIDs.utrProTennisTour.component}-${globalSearchIDs.utrProTennisTour.location}-${globalSearchIDs.utrProTennisTour.id}`,
                                                    })}
                                                >
                                                    UTR Pro Tennis Tour
                                                </button>
                                            </TrackedClick>
                                        </>
                                    )}

                                    <TrackedClick
                                        eventName="Global Search Category Clicked"
                                        label="Clubs"
                                        traits={{
                                            entityType: 'clubs',
                                        }}
                                    >
                                        <button
                                            className={`btn btn-sm btn-primary`}
                                            onClick={() => this.handleTypeFilterClick('clubs')}
                                            {...getClickAttrs({
                                                category: 'Global Search Category',
                                                context: `Clubs`,
                                                location: 'Global search CTA',
                                                testid: `${globalSearchIDs.clubs.component}-${globalSearchIDs.clubs.location}-${globalSearchIDs.clubs.id}`,
                                            })}
                                        >
                                            Clubs
                                        </button>
                                    </TrackedClick>
                                    {showTennisItems && (
                                        <>
                                            <TrackedClick
                                                eventName="Global Search Category Clicked"
                                                label="Colleges"
                                                traits={{
                                                    entityType: 'colleges',
                                                }}
                                            >
                                                <button
                                                    className={`btn btn-sm btn-primary`}
                                                    onClick={() => this.handleTypeFilterClick('colleges')}
                                                    {...getClickAttrs({
                                                        category: 'Global Search Category',
                                                        context: `Colleges`,
                                                        location: 'Global search CTA',
                                                        testid: `${globalSearchIDs.colleges.component}-${globalSearchIDs.colleges.location}-${globalSearchIDs.colleges.id}`,
                                                    })}
                                                >
                                                    Colleges
                                                </button>
                                            </TrackedClick>

                                            <TrackedClick
                                                eventName="Global Search Category Clicked"
                                                label="High Schools"
                                                traits={{
                                                    entityType: 'high schools',
                                                }}
                                            >
                                                <button
                                                    className={`btn btn-sm btn-primary`}
                                                    onClick={() => this.handleTypeFilterClick('highSchools')}
                                                    {...getClickAttrs({
                                                        category: 'Global Search Category',
                                                        context: `High Schools`,
                                                        location: 'Global search CTA',
                                                        testid: `${globalSearchIDs.highSchools.component}-${globalSearchIDs.highSchools.location}-${globalSearchIDs.highSchools.id}`,
                                                    })}
                                                >
                                                    High Schools
                                                </button>
                                            </TrackedClick>
                                            <TrackedClick
                                                eventName="Global Search Category Clicked"
                                                label="Paid Hits"
                                                traits={{
                                                    entityType: 'Paid Hits',
                                                }}
                                            >
                                                <button
                                                    className={`btn btn-sm btn-primary`}
                                                    onClick={() => this.handleTypeFilterClick(paidHits)}
                                                    {...getClickAttrs({
                                                        category: 'Global Search Category',
                                                        context: `Paid Hits`,
                                                        location: 'Global search CTA',
                                                        testid: `${globalSearchIDs.paidHits.component}-${globalSearchIDs.paidHits.location}-${globalSearchIDs.paidHits.id}`,
                                                    })}
                                                >
                                                    Paid Hits
                                                </button>
                                            </TrackedClick>
                                            <TrackedClick
                                                eventName="Global Search Category Clicked"
                                                label="Paid Hitters"
                                                traits={{
                                                    entityType: 'Paid Hit Clubs',
                                                }}
                                            >
                                                <button
                                                    className={`btn btn-sm btn-primary`}
                                                    onClick={() => this.handleTypeFilterClick(paidHitClubs)}
                                                    {...getClickAttrs({
                                                        category: 'Global Search Category',
                                                        context: `Paid Hitters`,
                                                        location: 'Global search CTA',
                                                        testid: `${globalSearchIDs.paidHitters.component}-${globalSearchIDs.paidHitters.location}-${globalSearchIDs.paidHitters.id}`,
                                                    })}
                                                >
                                                    Paid Hitters
                                                </button>
                                            </TrackedClick>
                                            <TrackedClick
                                                eventName="Global Search Category Clicked"
                                                label="Junior Circuits"
                                                traits={{
                                                    entityType: 'Junior Circuits',
                                                }}
                                            >
                                                <button
                                                    className={`btn btn-sm btn-primary`}
                                                    onClick={() => this.handleTypeFilterClick('juniorCircuits')}
                                                    {...getClickAttrs({
                                                        category: 'Global Search Category',
                                                        context: `Junior Circuits`,
                                                        location: 'Global search CTA',
                                                        testid: `${globalSearchIDs.juniorCircuits.component}-${globalSearchIDs.juniorCircuits.location}-${globalSearchIDs.juniorCircuits.id}`,
                                                    })}
                                                >
                                                    Junior Circuits
                                                </button>
                                            </TrackedClick>

                                            <TrackedClick
                                                eventName="Global Search Category Clicked"
                                                label="College Circuits"
                                                traits={{
                                                    entityType: 'College Circuits',
                                                }}
                                            >
                                                <button
                                                    className={`btn btn-sm btn-primary`}
                                                    onClick={() => this.handleTypeFilterClick('collegeCircuits')}
                                                    {...getClickAttrs({
                                                        category: 'Global Search Category',
                                                        context: `College Circuits`,
                                                        location: 'Global search CTA',
                                                        testid: `${globalSearchIDs.collegeCircuits.component}-${globalSearchIDs.collegeCircuits.location}-${globalSearchIDs.collegeCircuits.id}`,
                                                    })}
                                                >
                                                    College Circuits
                                                </button>
                                            </TrackedClick>

                                            <TrackedClick
                                                eventName="Global Search Category Clicked"
                                                label="Junior Regionals"
                                                traits={{
                                                    entityType: 'Junior Regionals',
                                                }}
                                            >
                                                <button
                                                    className={`btn btn-sm btn-primary`}
                                                    onClick={() => this.handleTypeFilterClick('juniorRegionals')}
                                                    {...getClickAttrs({
                                                        category: 'Global Search Category',
                                                        context: `Junior Regionals`,
                                                        location: 'Global search CTA',
                                                        testid: `${globalSearchIDs.juniorRegionals.component}-${globalSearchIDs.juniorRegionals.location}-${globalSearchIDs.juniorRegionals.id}`,
                                                    })}
                                                >
                                                    Junior Regionals
                                                </button>
                                            </TrackedClick>
                                            <TrackedClick
                                                eventName="Global Search Category Clicked"
                                                traits={{
                                                    entityType: 'Camps',
                                                }}
                                            >
                                                <button
                                                    className={`btn btn-sm btn-primary`}
                                                    onClick={() => this.handleTypeFilterClick('camps')}
                                                    {...getClickAttrs({
                                                        category: 'Global Search Category',
                                                        context: `Camps`,
                                                        location: 'Global search CTA',
                                                        testid: `${globalSearchIDs.camps.component}-${globalSearchIDs.camps.location}-${globalSearchIDs.camps.id}`,
                                                    })}
                                                >
                                                    Camps
                                                </button>
                                            </TrackedClick>
                                        </>
                                    )}
                                    {showPickleballItems && (
                                        <>
                                            <TrackedClick
                                                eventName="Global Search Category Clicked"
                                                label="Pickleball"
                                                traits={{
                                                    entityType: 'Pickleball',
                                                }}
                                            >
                                                <button
                                                    className={`btn btn-sm btn-primary`}
                                                    onClick={() => {
                                                        this.handleTypeFilterClick('pickleball');
                                                        this.props.updateSportTypes({ showTennisContent: false, showPickleballContent: true });
                                                    }}
                                                    {...getClickAttrs({
                                                        category: 'Global Search Category',
                                                        context: `Pickleball`,
                                                        location: 'Global search CTA',
                                                        testid: `${globalSearchIDs.pickleball.component}-${globalSearchIDs.pickleball.location}-${globalSearchIDs.pickleball.id}`,
                                                    })}
                                                >
                                                    Pickleball
                                                </button>
                                            </TrackedClick>
                                            <TeamLeaguesPickleballSearchPills onTeamLeagueClick={this.handleTeamLeagueClick} />
                                        </>
                                    )}
                                    <TrackedClick
                                        eventName="Global Search Category Clicked"
                                        label="Golden Ticket"
                                        traits={
                                            {
                                                entityType: 'Golden Ticket',
                                            }
}
                                    >
                                        <button
                                            className={`btn btn-sm btn-primary`}
                                            onClick={() => {
                                                const tours = {
                                                    'Golden Ticket': true,
                                                };
                                                this.handleTypeFilterClick('events', tours);
                                                this.props.updateSportTypes({ showPickleballContent: true });
                                            }}
                                            {...getClickAttrs({
                                                category: 'Global Search Category',
                                                context: `Golden Ticket`,
                                                location: 'Global search CTA',
                                                testid: `${globalSearchIDs.events.component}-${globalSearchIDs.events.location}-${globalSearchIDs.events.id}`,
                                            })}
                                        >
                                            Golden Ticket
                                        </button>
                                    </TrackedClick>
                                </div>
                            </div>
                        )}
                        {this.state.players.total === 0 && this.state.highSchools.total === 0 && this.state.colleges.total === 0 && this.state.clubs.total === 0 && this.state.events.total === 0 && !this.state.isLoading && this.state.searched && this.state.query && (
                            <div className={styles.globalSearchDropdownNoMatches}>
                                {mode === 'lookup' && !(this.state.searched && this.state.query?.length > 0) ? placeholder : 'No Matches Found'}
                            </div>
                        )}
                        {(this.state.players.total > 0 || this.state.highSchools.total > 0 || this.state.colleges.total > 0 || this.state.clubs.total > 0 || this.state.events.total > 0 || this.state.isLoading) && (
                            <div className={styles.globalSearchDropdownOptions}>
                                {this.state.players.hits.length !== 0 && (
                                    <React.Fragment>
                                        {mode === 'search' && (
                                            <TrackedClick
                                                eventName="Global Search See All Clicked"
                                                label={this.state.query}
                                                traits={{
                                                    entityType: 'players',
                                                    query: this.state.query,
                                                }}
                                            >
                                                <div
                                                    className={styles.searchTypeTitle}
                                                    {...getClickAttrs({
                                                        category: 'Global Search See All',
                                                        context: `See all players: ${this.state.query}`,
                                                        location: 'Global search CTA',
                                                        testid: `${globalSearchIDs.playersSeeAll.component}-${globalSearchIDs.playersSeeAll.location}-${globalSearchIDs.playersSeeAll.id}`,
                                                    })}
                                                >
                                                    Players
                                                    <a
                                                        href="#"
                                                        onClick={(e) => {
                                                            this.handleSeeAllClick(e, 'players');
                                                            this.props.applySearchFilters({
                                                                sportTypes: {
                                                                    tennis: this.props.auth?.user ? !!this.props?.auth?.feedPreferences?.showTennisContent : true,
                                                                    pickleball: this.props.auth?.user ? !!this.props?.auth?.feedPreferences?.showPickleballContent : true,
                                                                },
                                                            });
                                                            this.props.updateSportTypes(this.props.auth?.user ? this.props?.auth?.feedPreferences : { showTennisContent: true, showPickleballContent: true });
                                                        }}
                                                    >SEE ALL <i className="fas fa-long-arrow-alt-right bounce-right" />
                                                    </a>
                                                </div>
                                            </TrackedClick>
                                        )}
                                        {this.state.players.hits.map((player, i) => renderPlayer(player.source, i))}
                                    </React.Fragment>
                                )}
                                {this.state.events.hits.length !== 0 && (
                                    <React.Fragment>
                                        {mode === 'search' && (
                                            <TrackedClick
                                                eventName="Global Search See All Clicked"
                                                label={this.state.query}
                                                traits={{
                                                    entityType: 'events',
                                                    query: this.state.query,
                                                }}
                                            >
                                                <div
                                                    className={styles.searchTypeTitle}
                                                    {...getClickAttrs({
                                                        category: 'Global Search See All',
                                                        context: `See all events: ${this.state.query}`,
                                                        location: 'Global search CTA',
                                                        testid: `${globalSearchIDs.eventsSeeAll.component}-${globalSearchIDs.eventsSeeAll.location}-${globalSearchIDs.eventsSeeAll.id}`,
                                                    })}
                                                >
                                                    Events <a href="#" onClick={(e) => this.handleSeeAllClick(e, 'events')}>SEE ALL <i className="fas fa-long-arrow-alt-right bounce-right" /></a>
                                                </div>
                                            </TrackedClick>
                                        )}
                                        {this.state.events.hits.map((event, i) => renderEvent(event.source, i, 'events'))}
                                    </React.Fragment>
                                )}
                                {this.state.colleges.hits.length !== 0 && (
                                    <React.Fragment>
                                        {mode === 'search' && (
                                            <TrackedClick
                                                eventName="Global Search See All Clicked"
                                                label={this.state.query}
                                                traits={{
                                                    entityType: 'colleges',
                                                    query: this.state.query,
                                                }}
                                            >
                                                <div
                                                    className={styles.searchTypeTitle}
                                                    {...getClickAttrs({
                                                        category: 'Global Search See All',
                                                        context: `See all colleges: ${this.state.query}`,
                                                        location: 'Global search CTA',
                                                        testid: `${globalSearchIDs.collegesSeeAll.component}-${globalSearchIDs.collegesSeeAll.location}-${globalSearchIDs.collegesSeeAll.id}`,
                                                    })}
                                                >
                                                    Colleges <a href="#" onClick={(e) => this.handleSeeAllClick(e, 'colleges')}>SEE ALL <i className="fas fa-long-arrow-alt-right bounce-right" /></a>
                                                </div>
                                            </TrackedClick>
                                        )}
                                        {this.state.colleges.hits.map((school, i) => renderSchool(school.source, i))}
                                    </React.Fragment>
                                )}
                                {this.state.highSchools.hits.length !== 0 && (
                                    <React.Fragment>
                                        {mode === 'search' && (
                                            <TrackedClick
                                                eventName="Global Search See All Clicked"
                                                label={this.state.query}
                                                traits={{
                                                    entityType: 'highschools',
                                                    query: this.state.query,
                                                }}
                                            >
                                                <div
                                                    className={styles.searchTypeTitle}
                                                    {...getClickAttrs({
                                                        category: 'Global Search See All',
                                                        context: `See all high schools: ${this.state.query}`,
                                                        location: 'Global search CTA',
                                                        testid: `${globalSearchIDs.highSchoolsSeeAll.component}-${globalSearchIDs.highSchoolsSeeAll.location}-${globalSearchIDs.highSchoolsSeeAll.id}`,
                                                    })}
                                                >
                                                    High Schools <a href="#" onClick={(e) => this.handleSeeAllClick(e, 'highSchools')}>SEE ALL <i className="fas fa-long-arrow-alt-right bounce-right" /></a>
                                                </div>
                                            </TrackedClick>
                                        )}
                                        {this.state.highSchools.hits.map((school, i) => renderSchool(school.source, i))}
                                    </React.Fragment>
                                )}
                                {this.state.clubs.hits.length !== 0 && (
                                    <React.Fragment>
                                        {mode === 'search' && (
                                            <TrackedClick
                                                eventName="Global Search See All Clicked"
                                                label={this.state.query}
                                                traits={{
                                                    entityType: 'clubs',
                                                    query: this.state.query,
                                                }}
                                            >
                                                <div
                                                    className={styles.searchTypeTitle}
                                                    {...getClickAttrs({
                                                        category: 'Global Search See All',
                                                        context: `See all clubs: ${this.state.query}`,
                                                        location: 'Global search CTA',
                                                        testid: `${globalSearchIDs.clubsSeeAll.component}-${globalSearchIDs.clubsSeeAll.location}-${globalSearchIDs.clubsSeeAll.id}`,
                                                    })}
                                                >
                                                    Clubs <a href="#" onClick={(e) => this.handleSeeAllClick(e, 'clubs')}>SEE ALL <i className="fas fa-long-arrow-alt-right bounce-right" /></a>
                                                </div>
                                            </TrackedClick>
                                        )}
                                        {this.state.clubs.hits.map((club, i) => renderClub(club.source, i))}
                                    </React.Fragment>
                                )}
                                {this.state.isLoading && (
                                    <div className={styles.loading}><i className="fas fa-circle-notch fa-spin" />Loading...
                                    </div>
                                )}
                                {mode === 'lookup' && renderWaypoint()}
                            </div>
                        )}
                    </div>
                </div>
            );
        };

        return (
            <div className={styles.globalSearchWrapper}>
                <div
                    className={`${styles.globalSearchContainer} ${this.props.search.isExpanded ? `${styles.globalSearchContainerDisplay} expanded` : ''}`}
                    ref={this.setWrapperRef}
                >
                    <div
                        className={styles.globalSearchInputContainer}
                        data-testid={`${globalSearchIDs.searchInputContainer.component}-${globalSearchIDs.searchInputContainer.location}-${globalSearchIDs.searchInputContainer.id}`}

                    >
                        <span
                            className={`d-none d-lg-block ${'utr-icon icon-explore bs16'} ${this.state.showDropDown && styles.searchIconDropDownOpen} ${styles.feedbackLeft}`}
                        />
                        <span
                            className={`d-block d-lg-none fas fa-chevron-left ${styles.feedbackLeft}`}
                            onClick={this.handleSearchBackClick}
                            data-testid="header.global-search.back-btn"
                        />
                        <input
                            type="text"
                            ref="query"
                            className={`form-control ${styles.globalSearchInput} ${this.state.showDropDown && 'dropdown-open'} ${shouldShowVoiceflowEmbeddedChat ? styles.voiceflowEmbeddedInput : ''}`}
                            onKeyUp={this.handleKeyUp}
                            onPaste={this.handlePaste}
                            onFocus={this.handleOnFocus}
                            placeholder={mode === 'search' ? 'Search' : placeholder}
                            data-testid={`${globalSearchIDs.searchInput.component}-${globalSearchIDs.searchInput.location}-${globalSearchIDs.searchInput.id}`}
                        />
                        {this.state.query.length > 0 && (
                            <span
                                className={`form-control-feedback ${'utr-icon icon-close bs16'} ${styles.feedbackRight}`}
                                onClick={() => this.handleClearClick(true)}
                            />
                        )}
                    </div>
                    {this.state.showDropDown && (
                        <div
                            className={`${styles.globalSearchDropdownContainer} ${shouldShowVoiceflowEmbeddedChat ? styles.voiceflowEmbeddedMode : ''}`}
                            data-testid="global-search.dropdown-container"
                        >
                            {renderDropdown()}
                            {(allowInvite && lookup && this.state.searched && this.state.query?.length > 0 && lookupType === 'players') && (
                                <div
                                    className="invite-player"
                                    onClick={(ev) => this.handlePlayerClick({ query: this.state.query }, ev)}
                                >
                                    <div className="row">
                                        <div className="col-2 d-flex align-items-center">
                                            <div className="icon circled-add" />
                                        </div>
                                        <div className="col-10 text-dark">Can&apos;t find your
                                            opponent?<br />Invite <b>{this.state.query}</b> now!
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <div className={`${styles.searchExpander} ${this.props.auth?.user ? styles.auth : ''}`} onClick={this.handleSearchExpanderClick} data-testid={`${navigationIDs.explore.component}-${navigationIDs.explore.location}-${navigationIDs.explore.id}`}>
                    <span className={`fas utr-icon icon-explore`} />
                    <div className={styles.mobileLabel} data-testid="header.global-search.expand-btn.label">Search</div>
                </div>
                {this.state.showPopUp ? (
                    <WarningPopUp
                        confirmPopup={this.handlePopUpConfirm}
                        description={this.state.popUpMessage}
                    />
                )
                    : null}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearGlobalSearch: (clearGlobalSearch) => {
            dispatch(actions.clearGlobalSearch(clearGlobalSearch));
        },
        setSearchMode: async (mode) => {
            await dispatch(actions.setSearchMode(mode));
        },
        setTypeFilter: (typeFilter, reSearch) => {
            dispatch(actions.setTypeFilter(typeFilter, reSearch));
        },
        setGeoLocation: (geocoded) => {
            dispatch(actions.setGeoLocation(geocoded));
        },
        postScoreAddPlayer: (key, player) => {
            dispatch(postScoreActions.addPlayer({ key, player }));
        },
        expandSearch: (isExpanded) => {
            dispatch(actions.expandSearch(isExpanded));
        },
        storeResults: (query, results, resetTypeFilter) => {
            dispatch(actions.storeResults(query, results, resetTypeFilter));
        },
        setLoadingFlag: () => {
            dispatch(actions.setLoadingFlag());
        },
        applySearchFilters: (filters, reSearch) => {
            dispatch(actions.applySearchFilters(filters, reSearch));
        },
        changeFilterInputs: (filters) => {
            dispatch(actions.changeFilterInputs(filters));
        },
        updateSearchQuery: (query) => {
            dispatch(actions.updateQuery(query));
        },
        updateQueryParams: (bool) => {
            dispatch(actions.updateQueryParams(bool));
        },
        updateSportTypes: (feedPreferences) => dispatch(actions.updateSportTypes({ tennis: feedPreferences?.showTennisContent, pickleball: feedPreferences?.showPickleballContent })),
        getFeedPreferences: () => dispatch(getFeedPreferences()),
        showSplash: () => dispatch(showSplash()),

    };
}

function mapStateToProps({ auth, search, coreUI, header }) {
    return { auth, search, coreUI, header };
}
GlobalSearch.propTypes = {
    auth: PropTypes.instanceOf(Object).isRequired,
    coreUI: PropTypes.objectOf(any).isRequired,
    applySearchFilters: PropTypes.func.isRequired,
    updateSportTypes: PropTypes.func.isRequired,
    showGlobalSearchV2: PropTypes.bool,
    expandSearch: PropTypes.func.isRequired,
};

GlobalSearch.defaultProps = {
    showGlobalSearchV2: true,
};

export default withRouter(withStatsig(connect(mapStateToProps, mapDispatchToProps)(GlobalSearch)));
